import { render, staticRenderFns } from "./VideoFullscreen.vue?vue&type=template&id=32c15be4&scoped=true&"
import script from "./VideoFullscreen.vue?vue&type=script&lang=js&"
export * from "./VideoFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoFullscreen.vue?vue&type=style&index=0&id=32c15be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c15be4",
  null
  
)

export default component.exports